import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import contactData from '../../locales/contactData';

const AnyReactComponent = ({ text }) => <div>{text}</div>;
class GoogleMapStyle extends Component {
  static defaultProps = {
    center: {
      lat: contactData.address.coordinates.latitude || 0,
      lng: contactData.address.coordinates.longitude || 0,
    },
    zoom: 15,
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div className="google-map-style-1">
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
          }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent
            lat={contactData.address.coordinates.latitude}
            lng={contactData.address.coordinates.longitude}
            text={contactData.address.nameOnMap}
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default GoogleMapStyle;
